import { Outlet } from 'react-router-dom';
import { useTranslation } from '../../i18n';
import { SiteHeader } from './SiteHeader';
import { SiteFooter } from './SiteFooter';

/** Root layout: header, page content, footer, plus a keyboard skip link. */
export function AppShell() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col bg-bg">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:start-4 focus:top-4 focus:z-50 focus:rounded-lg focus:bg-brand focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-brand-fg"
      >
        {t('app.skipToContent')}
      </a>
      <SiteHeader />
      <main id="main-content" className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
